import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CardCustom } from "../../../shared/ui/container/CardCustom";
import { CustomerUsersTable } from "./users/CustomerUsersTable";
import {
	fetchAllAddableUserCustomer,
	fetchCustomerUsers,
	addUserCustomer,
	removeUserCustomer,
} from "../../../../redux/customers/customersActions";
import {
	selectCustomerAddableUsers,
	selectCustomerUsers,
	resetCustomerAddableUsers,
	resetCustomerUsers,
} from "../../../../redux/customers/customersSlice";
import {
	selectRoles,
} from "../../../../redux/gda/gdaSlice";
import { getAllRolesAction } from "../../../../redux/gda/gdaActions";
import { useLanguageForShared } from "../../../../shared/utils/languages/useLanguageForShared";

export function CustomerDetailUsers({ customer }) {
	const { t } = useLanguageForShared();
	const dispatch = useDispatch();
	const addableUsers = useSelector(selectCustomerAddableUsers);
	const customerUsers = useSelector(selectCustomerUsers);
	const roles = useSelector(selectRoles);

	useEffect(() => {
		if (customer?.id) {
			dispatch(fetchCustomerUsers(t, customer.id));
			dispatch(fetchAllAddableUserCustomer(t, customer.id));
			dispatch(getAllRolesAction(t));
		}
		return () => {
			dispatch(resetCustomerAddableUsers());
			dispatch(resetCustomerUsers());
		};
	}, [customer?.id]);

	const addUser = (row, callback) => {
		dispatch(addUserCustomer(t, customer.id, row, callback));
	};

	const removeUser = (row) => {
		dispatch(removeUserCustomer(t, customer.id, row));
	};

	return (
		<CardCustom title={t('action.users')}>
			<CustomerUsersTable
				users={addableUsers}
				selectedUsers={customerUsers}
				roles={roles}
				addUser={addUser}
				removeUser={removeUser}
			/>
		</CardCustom>
	);
}
